import { api } from './cliente.js';

export interface Portfolio {
  id: string;
  nome: string;
  objetivoEstrategico: string | null;
  tetoCapacidadeH: number;
  cadenciaRevisao: 'mensal' | 'trimestral';
  ultimaRevisao: string | null;
  criadoPor: string;
  criadoEm: string;
}

export interface IniciativaConsolidada {
  tipo: 'programa' | 'projeto';
  id: string;
  estado: string;
}

export interface Consolidado {
  iniciativas: IniciativaConsolidada[];
  usoCapacidadeH: number;
}

export interface Teto {
  usoH: number;
  tetoH: number;
  excedente: number;
}

export interface ContinuidadePendente {
  iniciativaTipo: string;
  iniciativaId: string;
}

export interface CenarioResultado {
  iniciativasRemovidas: string[];
  capacidadeLiberadaH: number;
}

export type DecisaoRevisao = 'Manter' | 'Acelerar' | 'Suspender' | 'Cancelar';

export interface DecisaoIniciativa {
  iniciativaTipo: 'programa' | 'projeto';
  iniciativaId: string;
  decisao: DecisaoRevisao;
  justificativa: string;
}

export const portfolioApi = {
  listar: () => api.get<Portfolio[]>('/portfolios'),
  consolidado: (id: string) => api.get<Consolidado>(`/portfolios/${id}/consolidado`),
  teto: (id: string) => api.get<Teto>(`/portfolios/${id}/teto`),
  continuidade: (id: string) => api.get<ContinuidadePendente[]>(`/portfolios/${id}/continuidade`),
  simular: (id: string, cancelamentos: string[]) => api.post<CenarioResultado>(`/portfolios/${id}/simulacao`, { cancelamentos }),
  executarRevisao: (id: string, tipo: 'ordinaria' | 'extraordinaria', decisoes: DecisaoIniciativa[]) =>
    api.post<{ id: string }>(`/portfolios/${id}/revisoes`, { tipo, decisoes }),
};
